import { render, staticRenderFns } from "./RegionCreate.vue?vue&type=template&id=71771493"
import script from "./RegionCreate.vue?vue&type=script&lang=js"
export * from "./RegionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports